import {SortingOrderEnum} from 'enums';
import {IInstrumentsAllSortOrder} from 'models';
import {InstrumentDropdownNameEnum, InstrumentsOrderingEnum} from '../enums';

export const getSortInstrumentMenuItemsList = (
  itemClickHandler: () => void,
  handleItemClick: (handleItemSortObj: IInstrumentsAllSortOrder) => void
) => {
  const onClick = (
    itemClickHandler: () => void,
    handleItemClick: (handleItemSortObj: IInstrumentsAllSortOrder) => void,
    handleItemSortObj: IInstrumentsAllSortOrder
  ) => {
    return () => {
      itemClickHandler();
      handleItemClick(handleItemSortObj);
    };
  };

  return [
    {
      name: InstrumentDropdownNameEnum.NAME_ASC,
      clickHandler: onClick(itemClickHandler, handleItemClick, {
        order: InstrumentsOrderingEnum.Name,
        sort: SortingOrderEnum.ASC,
      }),
    },
    {
      name: InstrumentDropdownNameEnum.NAME_DESC,
      clickHandler: onClick(itemClickHandler, handleItemClick, {
        order: InstrumentsOrderingEnum.Name,
        sort: SortingOrderEnum.DESC,
      }),
    },
    {
      name: InstrumentDropdownNameEnum.CREATED_NEWEST,
      clickHandler: onClick(itemClickHandler, handleItemClick, {
        order: InstrumentsOrderingEnum.Created,
        sort: SortingOrderEnum.DESC,
      }),
    },
    {
      name: InstrumentDropdownNameEnum.CREATED_OLDEST,
      clickHandler: onClick(itemClickHandler, handleItemClick, {
        order: InstrumentsOrderingEnum.Created,
        sort: SortingOrderEnum.ASC,
      }),
    },
  ];
};
